import { createMuiTheme } from "@material-ui/core";

const theme = createMuiTheme({
	typography: {
		fontFamily: `"Figtree", "Segoe UI", sans-serif`,
	},
});

theme.props = {
	MuiButton: {
		disableRipple: true,
		disableFocusRipple: true,
	},
	MuiInput: {
		disableUnderline: true,
	},
	MuiIconButton: {
		disableFocusRipple: true,
		disableRipple: true,
	},
};

theme.overrides = {
	MuiAppBar: {
		colorPrimary: {
			// Light product header — brand used as accent, not full wash
			backgroundColor: "var(--surface-bg)",
			color: "var(--color-dark-grey)",
		},
		root: {
			boxShadow: "none",
		},
	},
	MuiToolbar: {
		root: {
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center",
			color: "var(--color-dark-grey)",
			height: "100%",
			width: "100%",
			padding: "0px",
			minHeight: "var(--header-height)",
			gap: "12px",
		},
		gutters: {
			paddingLeft: 0,
			paddingRight: 0,
		},
	},
	MuiSwitch: {
		switchBase: {
			color: "var(--color-light-grey)",
		},
		colorSecondary: {
			"&$checked": {
				color: "var(--active-brand-color)",
			},
		},
		track: {
			opacity: 0.2,
			backgroundColor: "var(--color-light-grey)",
			"$checked$checked + &": {
				opacity: 0.7,
				backgroundColor: "var(--active-brand-color)",
			},
		},
	},
	MuiButton: {
		root: {
			fontSize: "var(--active-font-size)",
			fontFamily: `"Figtree", "Segoe UI", sans-serif`,
			background: "white",
			color: "var(--active-msg-bg)",
			border: "1px solid var(--active-msg-bg)",
			borderRadius: "12px",
			textTransform: "none",
			fontWeight: 600,
			transition: "opacity 0.15s ease, box-shadow 0.15s ease",
			padding: "7px 14px",
			"&:hover": {
				opacity: "0.92",
				backgroundColor: "white",
			},
			"&:focus": {
				outline: "none",
				boxShadow: "0 0 0 3px rgba(11, 79, 156, 0.2)",
			},
			"&:disabled": {
				borderColor: "var(--color-light-grey)",
			},
		},
	},
	MuiIconButton: {
		root: {
			"&:hover": {
				opacity: "0.85",
				backgroundColor: "rgba(15, 23, 42, 0.04)",
			},
		},
	},
	MuiDivider: {
		root: {
			backgroundColor: "var(--surface-border)",
		},
	},
	MuiBackdrop: {
		root: {
			top: "var(--header-height)",
			bottom: "0",
			borderRadius: "0 0 var(--radius-shell) var(--radius-shell)",
			backgroundColor: "rgba(248, 250, 252, 0.82)",
		},
	},
	MuiTypography: {
		colorPrimary: {
			color: "var(--color-dark-grey)",
			fontSize: "calc(var(--active-font-size) - 1px)",
		},
	},
	MuiTooltip: {
		tooltip: {
			fontFamily: `"Figtree", "Segoe UI", sans-serif`,
			fontSize: "12px",
			backgroundColor: "#0f172a",
		},
	},
};

export default theme;
